import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'

import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { AppConextProvider } from './store/AppContext'

import { Provider } from 'react-redux'
import { persistor, store } from '../src/redux/store'
import { PersistGate } from 'redux-persist/integration/react'

import reportWebVitals from './reportWebVitals'

// 🔵 Import Keycloak
import keycloak from './keycloak.js'

// 🔵 Create Keycloak instance using the config located in /public/keycloak.json
// const keycloak = new Keycloak('/keycloak.json')

// 🔵 Initialize Keycloak BEFORE rendering the React App
keycloak
  .init({
    onLoad: 'login-required', // Forces redirect to Keycloak login
    checkLoginIframe: false, // Disable iframe session checks (optional but recommended)
    pkceMethod: 'S256',
    // redirectUri: window.location.href
  })
  .then(authenticated => {
    const logoutInProgress = localStorage.getItem('kc_logout_in_progress')
    if (!authenticated && logoutInProgress) {

      sessionStorage.clear();
      localStorage.removeItem('user');
      localStorage.removeItem('accessToken');
      localStorage.removeItem('kc_logout_in_progress');

      console.warn('User not authenticated — redirecting to login.')
      // keycloak.login()
      return
    }

    localStorage.setItem('accessToken', keycloak.token)
    // sessionStorage.setItem('accessToken', keycloak.token)

    // 🔄 Auto-refresh token every 10 seconds
    setInterval(() => {
      keycloak
        .updateToken(30) // refresh if token expires in 30 sec
        .then(refreshed => {
          if (refreshed) {
            localStorage.setItem('accessToken', keycloak.token)
            console.log('🔄 Token refreshed')
          }
        })
        .catch(() => {
          console.log('⛔ Token refresh failed, logging out')
          keycloak.logout()
        })
    }, 10000)

    // 🔵 Render React App after Keycloak is ready
    const root = ReactDOM.createRoot(document.getElementById('root'))

    root.render(
      // <React.StrictMode>
      <AppConextProvider>
        <BrowserRouter>
          <Routes>
            <Route
              path='/*'
              element={
                <Provider store={store}>
                  <PersistGate loading={null} persistor={persistor}>
                    <App keycloak={keycloak} />
                  </PersistGate>
                </Provider>
              }
            />
          </Routes>
        </BrowserRouter>
      </AppConextProvider>
      // </React.StrictMode>
    )
  })
  .catch(err => {
    console.error('❌ Keycloak initialization failed', err)
  })

reportWebVitals()
 